export class ContactRequest{
    email: String;
    message: String;
    constructor(){
        this.email = "";
        this.message = "";
     }
}